<template>
  <div id="headerBox" :class="['headerBox', 'scrollLeft', scrollDown ? 'scrollDown' : '',headerType===1?'headerBox1':'']">
    <div class="logo">
      <router-link to="/">
        <img src="@/assets/image/index/logo.png" alt="" />
      </router-link>
    </div>
    <div class="menus"   @mouseover="isHovered = true" @click="handleClick">
      <div
        v-for="(item, index) in menuList"
        :key="item.path"
        :class="['menuItem', item.path == currentPath ? 'active' : '']"
      >
        <router-link :to="item.path">
          <img
            v-if="item.nameSpan"
            :src="require(`@/assets/${item.nameSpan}`)"
            :style="{
              width: '0.28rem',
              height: '0.29rem',
              verticalAlign: 'middle'
            }"
          />
          {{ item.name }}
        </router-link>
        <!-- 下拉子菜单 -->
        <div v-if="item.children && item.type === '1'" class="menuItemList1"   @mouseover="isHovered = true"  @mouseout="isHovered = true" @click="handleClick"
             :style="{ display: isHovered ? 'block' : 'none' }">
          <router-link
            v-for="child in item.children"
            :key="child.path"
            :to="{
              path: child.path,
              query: child.query
            }"
            :class="[
              'childItem',
              child.path == currentFullPath ? 'active' : '',
              child.path ==''||child.path==undefined?'disabled-cursor':''
            ]"
            >{{ child.name }}</router-link
          >
        </div>
        <!-- 产品中心子菜单 -->
        <div
          v-if="item.children && item.type === '2'"
          class="menuItemList2 scrollLeft"
          @mouseover="isHovered = true"
          :style="{ display: isHovered ? 'block' : 'none' }"
        >
          <div v-for="child in item.children" class="mlist2Item">
            <div class="left">{{ child.name }}</div>
            <div class="right">
              <div v-for="child2 in child.list" class="rgItem">
                <div class="mlist2title1">{{ child2.name }}</div>
                <div class="mlist2title2" @click="handleClick"
                     @mouseout="isHovered = true">
                  <router-link
                    :class="[child3.path ==''||child3.path==undefined?'disabled-cursor':'']"
                    v-for="child3 in child2.pathList"
                    :key="child3.path"
                    :to="{
                      path: child3.path
                    }"
                    ><span>
                      {{ child3.name }}
                    </span></router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 解决方案子菜单 -->
        <div
          v-if="item.children && item.type === '3'"

          @mouseover="isHovered = true"
          :style="{ display: isHovered ? 'block' : 'none' }"
        >
          <div  class="menuItemList3 scrollLeft">
            <div v-for="child in item.children" class="mlist3Item">
              <div class="mlist3title1">
                <img :src="require(`@/assets/${child.icon}`)" alt="" />
                {{ child.name }}
              </div>
              <div class="mlist3title2" @click="handleClick"
                   @mouseout="isHovered = true">
                <router-link
                  :class="[child3.path ==''||child3.path==undefined?'disabled-cursor':'']"
                  v-for="child3 in child.pathList"
                  :key="child3.path"
                  :to="{
                  path: child3.path
                }"
                >
                <span>
                  {{ child3.name }}
                </span>
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="rgCon">
      <div class="mobile">

        <img
          style="width: 0.09rem;height: 0.14rem;margin-right: 0.1rem"
          src="../../assets/image/header-mobile.png"
        />
        <span>商务合作:</span>
        <a class="tel" href="tel:18665393445">18665393445</a>
        <span style="margin-left: 0.2rem">网络问题:</span>
        <a class="tel" href="tel:400-666-5780">400-666-5780</a>
      </div>
    </div>
<!--     <astronaut />-->
  </div>
</template>

<script>
import astronaut from "../astronaut";
import menu from "./menu";

export default {
  name: "Header",
  components: { astronaut },
  data() {
    return {
      scrollDown: false,
      menuList: menu,
      currentPath: null, //一级菜单path高亮
      currentFullPath: null, //二级菜单path高亮,
      headerType:0,
      isHovered:true
    };
  },
  created() {
    // alert("??")
    // var _hmt = _hmt || [];
    // var hm = document.createElement("script");
    // hm.src = "https://hm.baidu.com/hm.js?a3b94a9fc1a05dbf79a632261cbbca3e";
    // var s = document.getElementsByTagName("script")[0];
    // s.parentNode.insertBefore(hm, s);
    var _czc = _czc || [];
    (function () {
      var um = document.createElement("script");
      um.src = "https://v1.cnzz.com/z.js?id=1281355746&async=1";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(um, s);
    })();
  },
  watch: {
    $route(to, from) {
      this.handleMenuActive(to);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
    this.handleMenuActive(this.$route);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleClick(){
      this.isHovered=false;
      // const elements = document.querySelectorAll('.menuItemList2'); // 假设每个菜单项都有类名为menu-item
      // elements.forEach((element) => {
      //   element.style.opacity = '0';
      // });
    },
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollDown = scrollHeight > 90 ? true : false;

      const scrollLeftElements = document.querySelectorAll(".scrollLeft");

      scrollLeftElements.forEach(element => {
        element.style.marginLeft =
          "-" +
          (window.pageXOffset ||
            document.documentElement.scrollLeft ||
            document.body.scrollLeft) +
          "px";
      });
    },
    handleMenuActive(pathParams = {}) {
      const { fullPath = "", path = "", meta = {} } = pathParams || {},
        { activePath = "" } = meta;
      console.log(meta.headerType)
      this.headerType=meta.headerType===undefined?0:meta.headerType;
      this.currentPath = activePath ? activePath : path;
      this.currentFullPath = fullPath;
    }
  }
};
</script>

<style scoped lang="scss">
.headerBox {
  width: 100%;
  min-width: 1208px;
  // overflow: hidden;
  height: 0.88rem;
  position: fixed;
  background-color: transparent;
  border-bottom: 0.01rem solid #666666;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.8rem;
  font-size: 0.16rem;
  color: #fff;
  transition: all 0.3s ease-in-out;
  z-index: 888;
  &:hover {
    background-color: #000;
    border-bottom: 0.01rem solid #000;
  }
  .logo {
    height: 0.69rem;
    img {
      height: 100%;
      width: auto;
    }
  }
  .menus {
    display: flex;
    align-items: center;
    .menuItem {
      margin-right: 0.6rem;
      position: relative;
      height: 0.88rem;
      line-height: 0.88rem;
      display: flex;
      align-items: center;
      > span {
        font-size: 0.28rem;
        margin-right: 0.02rem;
        vertical-align: middle;
        text-shadow: 0px 3px 6px #fef100;
      }
      &:before {
        content: "";
        position: absolute;
        top: 0.2rem;
        left: 0;
        width: 0;
        height: 0.01rem;
        background: #fef100;
        opacity: 0;
        transition: all 0.3s ease-in-out;
      }
      &:hover {
        color: #fef100;
      }
      &.active {
        color: #fef100;
        &:before {
          width: 70%;
          opacity: 1;
        }
      }
      &:hover .menuItemList1 {
        height: auto;
        opacity: 1;
      }
      .menuItemList1 {
        position: absolute;
        top: 0.88rem;
        left: 0;
        background-color: rgba(#000000, 0.8);
        min-width: 1.48rem;
        box-sizing: border-box;
        transition: height 0.3s ease-in-out;
        height: 0;
        opacity: 0;
        overflow: hidden;
        line-height: 1.5;
        .childItem {
          padding: 0.1rem 0.2rem;
          color: #fff;
          display: inline-block;
          font-size: 0.16rem;
          &:first-child {
            padding-top: 0.2rem;
          }
          &:last-child {
            padding-bottom: 0.2rem;
          }
          &.active {
            color: #fef100;
          }
          &:hover {
            color: #fef100;
          }
        }
      }
      // 产品中心子菜单
      &:hover .menuItemList2 {
        height: auto;
        opacity: 1;
        padding: 0.48rem 2.7rem;
      }
      .menuItemList2 {
        position: fixed;
        top: 0.88rem;
        left: 0;
        width: 100%;
        min-width: 1208px;
        background-color: rgba(#000000, 0.8);
        box-sizing: border-box;
        transition: height 0.3s ease-in-out;
        line-height: 1.5;
        color: #fff;
        font-size: 0.16rem;
        max-height: calc(100vh - 0.88rem);
        overflow-y: auto;
        // padding: 0.48rem 2.7rem;
        padding: 0;
        height: 0;
        opacity: 0;
        overflow: hidden;
        .mlist2Item {
          display: flex;
          margin-bottom: 0.4rem;
          .left {
            width: 2.2rem;
            text-align: right;
            padding-right: 0.4rem;
            font-size: 0.2rem;
            border-right: 1px solid #666666;
          }
          .right {
            flex: 1;
            padding-left: 0.4rem;
            .rgItem {
              border-bottom: 1px solid #666666;
              margin-bottom: 0.2rem;
              padding-bottom: 0.2rem;
              .mlist2title1 {
                font-size: 0.18rem;
                color: #fef100;
                //margin-bottom: 0.2rem;
              }
              .mlist2title2 {

                span {
                  &:hover{
                    color: #fef100;
                  }
                  display: inline-block;
                  margin-right: 0.4rem;
                  margin-top: 0.2rem;
                }
              }
              &:last-child {
                margin-bottom: 0;
                border-bottom: 0;
                padding-bottom: 0;
              }
            }
          }
        }
      }
      // 解决方案子菜单
      &:hover .menuItemList3 {
        height: auto;
        opacity: 1;
        padding: 0.4rem 0rem 0.4rem 5.6rem;
      }
      .menuItemList3 {
        position: fixed;
        top: 0.88rem;
        left: 0;

        width: 100%;
        min-width: 1208px;
        background-color: rgba(#000000, 0.8);
        box-sizing: border-box;
        transition: height 0.3s ease-in-out;
        line-height: 1.5;
        color: #fff;
        font-size: 0.16rem;
        max-height: calc(100vh - 0.88rem);
        overflow-y: auto;
        display: flex;
        //justify-content: center;
        // padding: 0.4rem 0;
        padding: 0;
        height: 0;
        opacity: 1;

        .mlist3Item {
          margin: 0 0.4rem;
          .mlist3title1 {
            > img {
              width: 0.16rem;
              height: 0.16rem;
              margin-right: 0.1rem;
            }
            font-size: 0.18rem;
            color: #fef100;
            margin-bottom: 0.2rem;
          }
          .mlist3title2 {
            span {
              &:hover{
                color: #fef100;
              }
              display: block;
              margin-bottom: 0.1rem;
            }
          }
        }
      }
    }
  }

  .rgCon {
    .mobile {
      display: flex;
      align-items: center;
      .tel {
        font-size: 0.16rem;
        margin-left: 0.02rem;
      }
    }
  }
}

.scrollDown {
  background-color: #000;
  border-bottom: 0.01rem solid #000;
  color: #fff;
}
.headerBox1{
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue